<template>
  <div class="code-editor">
    <codemirror v-model="currentValue" :options="options" ref="editor"></codemirror>
  </div>
</template>
<script>
import { codemirror } from 'vue-codemirror'
import 'codemirror/mode/clike/clike.js'
import 'codemirror/mode/python/python.js'
import 'codemirror/theme/solarized.css'
import 'codemirror/theme/monokai.css'
import 'codemirror/theme/solarized.css'
import 'codemirror/theme/material.css'
import 'codemirror/theme/dracula.css'
//import "codemirror/theme/mdn-like.css"; // 这里引入的是主题样式，根据设置的theme的主题引入，一定要引入！！
import "codemirror/theme/idea.css"; // 这里引入的是主题样式，根据设置的theme的主题引入，一定要引入！！
import "codemirror/theme/darcula.css"; // 这里引入的是主题样式，根据设置的theme的主题引入，一定要引入！！


export default {
  name: 'CodeMirror',
  data() {
    return {
      currentValue: '',
      options: {
        mode: 'text/x-csrc',
        lineNumbers: true,
        lineWrapping: false,

        theme: 'darcula',
        tabSize: 4,
        line: true,
        foldGutter: true,
        gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
        autofocus: true
      }
    }
  },
  components: {
    codemirror
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    mode: {
      type: String,
      default: 'text/x-csrc'
    }
  },
  mounted() {

    this.currentValue = this.value
    // this.$refs.editor.editor.setOption('mode', this.mode)
  },
  watch: {
    'value'(val) {
      if (this.currentValue !== val) {
        this.currentValue = val
      }
    },
    'currentValue'(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('change', newVal)
        this.$emit('input', newVal)
      }
    },
    // 'mode'(newVal) {
    //   // this.$refs.editor.editor.setOption('mode', newVal)
    // }
  },

}
</script>

<style scoped>
/* .CodeMirror {
  height: auto !important;
} */

.CodeMirror-scroll {
  /* height: 100%;
  padding-bottom: 0px;
  margin-bottom: 0px;
  overflow-y: scroll; */
  min-height: 300px;
  max-height: 1000px;
}
/deep/ .CodeMirror {
  width: 100%;
  height: 100% !important;
  overflow-x: hidden;
}

/deep/ .cm-comment {
  font-style: initial !important;
}
/deep/ .cm-def {
  font-style: initial !important;
}
</style>
